// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[style*="--aspect-ratio"] > img {
  height: auto;
}

[style*="--aspect-ratio"] {
  position: relative;
}

[style*="--aspect-ratio"] > :first-child {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

[style*="--aspect-ratio"]::before {
  content: "";
  display: block;
  width: 100%;
}

@supports not (aspect-ratio: 1/1) {
  [style*="--aspect-ratio"]::before {
    height: 0;
    padding-bottom: calc(100% / (var(--aspect-ratio)));
  }
}

@supports (aspect-ratio: 1/1) {
  [style*="--aspect-ratio"]::before {
    aspect-ratio: calc(var(--aspect-ratio));
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-aspect-ratio/aspect-ratio.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,SAAS;IACT,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF","sourcesContent":["[style*=\"--aspect-ratio\"] > img {\n  height: auto;\n}\n\n[style*=\"--aspect-ratio\"] {\n  position: relative;\n}\n\n[style*=\"--aspect-ratio\"] > :first-child {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n[style*=\"--aspect-ratio\"]::before {\n  content: \"\";\n  display: block;\n  width: 100%;\n}\n\n@supports not (aspect-ratio: 1/1) {\n  [style*=\"--aspect-ratio\"]::before {\n    height: 0;\n    padding-bottom: calc(100% / (var(--aspect-ratio)));\n  }\n}\n\n@supports (aspect-ratio: 1/1) {\n  [style*=\"--aspect-ratio\"]::before {\n    aspect-ratio: calc(var(--aspect-ratio));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
